export const pdfView = {
  voiceTooltip: '松开发送，上划取消',
  alreadyDelete: '图纸已被删除',
  title: '施工图',
  hideAnnot: '隐藏标注',
  showAnnot: '显示标注',
  showNote: '看图钉',
  showCallout: '看引线',
  showShape: '看图形',
  send2Member: '发送给项目成员',
  cancel: '取消',
  loading: '加载中',
  addCommentTooltip: '点击图纸添加评论',
  alert: '隐藏标注下不能添加评论',
  errorMsg: 'PDF 打开异常，请刷新重试！',
  refreshButton: '刷新',
  addPointMessage: '请先选择2个点校准测量工具',
  OK: '好的'
}
